import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LocalizationPipe } from '@abp/ng.core';
import { ImportStatus } from '../../models';

@Component({
  selector: 'app-progress-circle',
  standalone: true,
  imports: [CommonModule, LocalizationPipe],
  templateUrl: './progress-circle.component.html',
  styleUrls: ['./progress-circle.component.scss'],
})
export class ProgressCircleComponent {
  @Input() progress = 0;
  @Input() status: ImportStatus = ImportStatus.NotStarted;
  @Output() click = new EventEmitter<MouseEvent>();

  get circumference(): number {
    return 2 * Math.PI * 45;
  }

  get strokeDashoffset(): number {
    return this.circumference - (this.progress / 100) * this.circumference;
  }

  get progressClass(): string {
    return ImportStatus[this.status].toLowerCase();
  }

  onCircleClick(event: MouseEvent): void {
    this.click.emit(event);
  }
}

